<template>
    <div>
        <div class="hero">
            <div class="hero__item">
                <div class="hero__image hero__image--home hero__image--buy-energy-header"></div>
            </div>
        </div>
        <ProductBox :modeljson="modeljson" :stringsjson="stringsjson" />
    </div>
</template>

<script>
    import ProductBox from './ProductBox'

    export default {
        props: {
            modeljson: String,
            stringsjson: String
        },
        components: {
            ProductBox
        }
    };
</script>